import { Card } from "@edp-models/benefits.model";
import {
    ComparatorEfficientHouse,
    ComparatorElectricMobility,
    ContractEfficiency,
    ContractPsData,
} from "@edp-models/energy-efficiency.model";

export interface IEnergyEfficiencyState {
    contractEfficiency: ContractEfficiency;
    productServiceCardData: ContractPsData[];
    contentCardData: Card[];
    comparatorEfficientHouse: ComparatorEfficientHouse;
    comparatorElectricMobility: ComparatorElectricMobility;
}

export const initialEnergyEfficiencyState: IEnergyEfficiencyState = {
    contractEfficiency: undefined,
    productServiceCardData: [],
    contentCardData: [],
    comparatorEfficientHouse: null,
    comparatorElectricMobility: null,
};
